/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_AdvertiseInputs */

const en_directory_footer_link_advertise = /** @type {(inputs: Directory_Footer_Link_AdvertiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsorship`)
};

const zh_directory_footer_link_advertise = /** @type {(inputs: Directory_Footer_Link_AdvertiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赞助位`)
};

/**
* | output |
* | --- |
* | "Sponsorship" |
*
* @param {Directory_Footer_Link_AdvertiseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_advertise = /** @type {((inputs?: Directory_Footer_Link_AdvertiseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_AdvertiseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_advertise(inputs)
	return zh_directory_footer_link_advertise(inputs)
});
export { directory_footer_link_advertise as "directory.footer.link_advertise" }